<template>
    <div class="page-header">
        <router-link class="btn btn-back" :to="{ path:'/Admin/List' }"><i class="las la-angle-left"></i></router-link>
    </div>
    <div class="voice-view">
        <div class="voice-rec">
            <div class="voice-script">
                <span>{{ comp.view.script }}</span><br>
                <span class="pron">[{{ comp.view.pronunciation }}]</span>
            </div>
            <div class="btn-box" :class="{ 'rec-end':comp.info.mergeURL!=null, 'hide':comp.mp3up.is_show==true }">
                <button class="btn btn-rec" :class="{ 'active':comp.info.mergeURL!=null }" @click="comp.onRecording" aria-label="voice rec">
                    <i v-if="comp.info.status==0" class="las la-microphone"></i>
                    <span v-if="comp.info.status==1">...</span>
                    <i v-if="comp.info.status==2" class="las la-stop"></i>
                </button>
                <button class="btn btn-play" :class="{ 'active':comp.info.mergeURL!=null }" @click="comp.onPlay('')" aria-label="rec voice play">
                    <i v-if="comp.play.status==0" class="las la-play"></i>
                    <i v-if="comp.play.status==1" class="las la-headphones"></i>
                </button>
                <button class="btn btn-native" :class="{ 'active':comp.info.mergeURL!=null, 'checked':comp.info.isnative==true }" @click="comp.info.isnative=!comp.info.isnative">Native</button>
                <button class="btn btn-send" :class="{ 'active':comp.info.mergeURL!=null }" @click="comp.onSendVoice()" aria-label="send voice to server"><i class="lar la-paper-plane"></i></button>

                <button class="btn btn-up-open" :class="{ 'hide':comp.info.mergeURL!=null||comp.info.status!=0 }" @click="comp.mp3up.is_show=true" aria-label="file upload show"><i class="las la-cloud-upload-alt"></i></button>
            </div>
            <audio id="audioplayer" class="rr-voice" :src="comp.info.mergeURL" @ended="comp.gotEnded"></audio>

            <div class="upload-box" :class="{ 'hide':comp.mp3up.is_show!=true }">
                <button class="btn-close" :class="{ 'active':comp.mp3up.is_native=='Y' }" @click="comp.hideMp3UpBox()" aria-label="file upload hide"><i class="las la-times-circle"></i></button>
                <ReumFileUploader class="up-file" accept="audio/mp3" v-model:filename="comp.mp3up.filename" v-model:url="comp.mp3up.url"></ReumFileUploader>
                
                <button class="btn-up-submit" v-if="comp.mp3up.url!=''" @click="comp.uploadMp3()" aria-label="file upload to server"><i class="las la-cloud-upload-alt"></i></button>
                <div class="chk-native"><label><button class="btn-isnative" :class="{ 'active':comp.mp3up.is_native=='Y' }" @click="comp.checkUpNative()" aria-label="check native"><i class="las la-check-circle"></i></button> is Native Voice?</label></div>
            </div>
        </div>

        <div class="bar"><span>voice list</span></div>

        <div class="voice-list">
            <div class="voice-item grade-info">
                <div class="voice-body">
                    <div class="script">
                        <span class="best">● best <input type="text" class="base-lv" v-model="comp.control.base.best" maxlength="3"></span>
                        <span class="good">● good <input type="text" class="base-lv" v-model="comp.control.base.good" maxlength="3"></span>
                        <span class="average">● average <input type="text" class="base-lv" v-model="comp.control.base.average" maxlength="3"></span>
                        <span class="fair">● fair <input type="text" class="base-lv" v-model="comp.control.base.fair" maxlength="3"></span>
                        <span class="poor">● poor <input type="text" readonly class="base-lv" v-model="comp.control.base.poor" maxlength="3"></span>
                        <span class="pitch-weight">● pitch weight <input type="text" class="base-lv" v-model="comp.control.base.pitch_weight" maxlength="3"></span>
                        <button class="btn-apply" @click="comp.doEvaluates">Apply</button>
                    </div>
                </div>
            </div>
            <!-- 학습자 START -->
            <template v-for="(irow, i) in comp.list" :key="i">
                <div class="voice-item" v-if="irow.isnative=='N'" :voice-len="irow.len_tot" :avg-score="irow.avg_score" :avg-grade="irow.avg_grade">
                    <div class="voice-head">
                        {{ i+1 }}
                    </div>
                    <div class="voice-body">
                        <div class="script" @click="pop.showView(irow)">
                            <span>{{ irow.script }}</span><br>
                            <template v-for="(jrow, j) in irow.phonemes" :key="j">
                                <!-- <span v-if="j>0">·</span> -->
                                <span :score="jrow.score" :class="comp.mkClass(irow, j)" @hover="comp.onHover(j)" :token="jrow.token_txt">{{ jrow.token_txt }}</span>
                            </template>
                        </div>

                        <div class="script">
                            <div v-if="irow.avg_score">
                                <span class="speech" v-if="irow.avg_score">SCORE : {{ irow.avg_score.toFixed(1) }}</span>
                                <span class="speech" v-if="irow.avg_score">GRADE : <span :class="irow.avg_grade">{{ irow.avg_grade }}</span></span>
                                <br>
                                <!-- pitch dir -->
                                <span class="speech" v-if="irow.avg_score">SCORE(pitch+) : {{ irow['avg_score_p'].toFixed(1) }}</span>
                                <span class="speech" v-if="irow.avg_score">GRADE(pitch+) : <span :class="irow['avg_grade_p']">{{ irow['avg_grade_p'] }}</span></span>
                                <span class="speech" v-if="irow.avg_score">Pitch Best : {{ irow['pitch_answer_best'] }}</span>
                            </div>
                            <div>
                                <span class="speech" v-if="irow.avg_score">Speech Time : {{ (irow.len_tot/1000).toFixed(2) }}s</span>
                                <span class="speech" v-else>{{ irow.avg_score?'':'(평가실패)' }}</span>
                                <span class="speech" v-if="irow.avg_score">WPM : {{ (irow.words_cnt/((irow.len_tot/1000)/60)).toFixed(2) }}w/m</span>
                            </div>
                        </div>
                        <div class="body-tail">
                            <label><input type="checkbox" v-model="irow.native" @change="comp.updateNative(irow.idx)"> Native?</label>
                            <label>
                                Evaluator Score : 
                                <input type="text" class="demo-score" maxlength="4" v-model="irow.demo_no" @blur="comp.updateScore(irow)">
                            </label>
                        </div>
                    </div>
                    <div class="voice-tail">
                        <button type="button" class="btn btn-play" @click="comp.onPlay(irow)">
                            <i v-if="comp.play.idx==irow.idx" class="las la-volume-up"></i>
                            <i v-else class="las la-play"></i>
                        </button>
                    </div>
                </div>
            </template>
            <!-- 학습자 END -->
            <!-- 원어민 START -->
            <template v-for="(irow, i) in comp.list" :key="i">
                <div class="voice-item" v-if="irow.isnative=='Y'" :voicelen="irow.len_tot">
                    <div class="voice-head">
                        <button type="button" class="btn btn-check" :class="{ 'checked':comp.selected.indexOf(irow.idx)>-1 }" @click="comp.selectNative(irow.idx)">
                            <i class="las la-check"></i>
                        </button>
                        <span class="idx">{{ irow.idx }}</span>
                    </div>
                    <div class="voice-body">
                        <!-- <span class="script">{{ irow.script }}</span> -->
                        <!-- <span class="script" @click="comp.doEvaluate(irow)"> -->
                        <span class="script">
                            {{ irow.script }}
                            <br>
                            <template v-for="(jrow, j) in irow.phonemes" :key="j">
                                <!-- <span v-if="j>0">·</span> -->
                                <span :score="jrow.score" :class="comp.mkClass(irow, j)" @hover="comp.onHover(j)">{{ jrow.token_txt }}</span>
                            </template>
                            <span class="speech">Speech Time : {{ (irow.len_tot/1000).toFixed(2) }}s</span>
                            <span class="speech">WPM : {{ (irow.words_cnt/((irow.len_tot/1000)/60)).toFixed(2) }}w/m</span>
                        </span>
                        <div class="body-tail">
                            <label><input type="checkbox" v-model="irow.native" @change="comp.updateNative(irow.idx)"> Native?</label>
                        </div>
                    </div>
                    <div class="voice-tail">
                        <button type="button" class="btn btn-play" @click="comp.onPlay(irow)">
                            <i v-if="comp.play.idx==irow.idx" class="las la-volume-up"></i>
                            <i v-else class="las la-play"></i>
                        </button>
                    </div>
                </div>
            </template>
            <!-- 원어민 END -->
        </div>

        <audio id="audioplayer2" class="rr-voice" :src="comp.play.vpath" @ended="comp.gotEnded"></audio>


        <!-- modal -->
        <div class="modal" :class="{ 'open':pop.view.show=='Y' }">
            <div class="modal-close" @click="pop.hideView()"></div>
            <div class="modal-pop">
                <div class="close" @click="pop.hideView()"><i class="lar la-times-circle"></i></div>
                <div class="modal-body">
                    <div class="ex-box result-box">
                        <!-- pitch analysis chart -->
                        <div class="chart">
                            <PitchChart :width="pop.pitch.w" :height="pop.pitch.h" :labels="pop.pitch.labels" :datalist="pop.pitch.datalist"></PitchChart>
                        </div>

                        <!-- intensity analysis chart -->
                        <div class="chart" style="margin-top:10px">
                            <IntensityChart :width="pop.intensity.w" :height="pop.intensity.h" :labels="pop.intensity.labels" :datalist="pop.intensity.datalist"></IntensityChart>
                        </div>

                        <div>
                            <div class="tit">[Result]</div>
                            <span class="script">
                                <span class="speech">SCORE : {{ pop.view.avg_score.toFixed(1) }}</span>
                                <span class="speech">GRADE : <span class="speech" :class="pop.view.avg_grade">{{ pop.view.avg_grade }}</span></span>
                                <span class="speech">Speech Time : {{ (pop.view.len_tot/1000).toFixed(2) }}s</span>
                                <span class="speech">WPM : {{ (pop.view.words_cnt/((pop.view.len_tot/1000)/60)).toFixed(2) }}w/m</span>
                            </span>
                            <div class="tit">[Script]</div>
                            <span>
                                <span>{{ pop.view.text }}</span>
                                <button type="button" class="btn btn-play" @click="comp.onPlay(pop.view)">
                                    <i v-if="comp.play.idx==pop.view.idx" class="las la-volume-up"></i>
                                    <i v-else class="las la-play"></i>
                                </button>
                            </span><br>
                            <template v-for="(irow, i) in pop.view.phonemes" :key="i">
                                <span :score="irow.score" :class="{ 'hover':pop.view.hover==i }"><span :class="comp.mkClass(pop.view, i)" @mouseover="pop.onHover(i)" @mouseleave="pop.onHover(-1)" @click="pop.onSelect(i)">{{ irow.token_txt }}</span></span>
                            </template>
                        </div>

                        <div>
                            <div class="tit">[Pronunciation]</div>
                            <template v-for="(irow, i) in pop.view.phonemes" :key="i">
                                <span :class="{ 'hover':pop.view.hover==i }"><span :class="comp.mkClass(pop.view, i)" @mouseover="pop.onHover(i)" @mouseleave="pop.onHover(-1)" @click="pop.onSelect(i)">{{ irow.pron_txt }}</span></span>
                            </template><br>
                            <template v-for="(irow, i) in pop.view.phonemes" :key="i">
                                <span :score="irow.score" :class="{ 'hover':pop.view.hover==i }"><span :class="comp.mkClass(pop.view, i)" @mouseover="pop.onHover(i)" @mouseleave="pop.onHover(-1)" @click="pop.onSelect(i)">{{ irow.stress>'0.0'?irow.token_txt.toUpperCase():irow.token_txt.toLowerCase() }}</span></span>
                            </template>
                        </div>
                        <div>
                            <div class="tit">[Token]</div>
                            <template v-for="(irow, i) in pop.view.phonemes" :key="i">
                                <span v-if="i>0"><span>·</span></span>
                                <span :score="irow.score" :class="{ 'hover':pop.view.hover==i }"><span :class="comp.mkClass(pop.view, i)" @mouseover="pop.onHover(i)" @mouseleave="pop.onHover(-1)" @click="pop.onSelect(i)">{{ irow.token }}</span></span>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="ex-pron" v-if="pop.phoneme.show">
                    <div class="ex-bg" @click="pop.deSelect()"></div>
                    <div class="ex-box">
                        <button class="btn-ex-close" @click="pop.deSelect()"><i class="lar la-times-circle"></i></button>
                        <table>
                            <tr>
                                <th rowspan="2">Phoneme<br>Pronunciation</th>
                                <th :colspan="pop.phoneme.list.length">{{ pop.phoneme.token }}</th>
                            </tr>
                            <tr>
                                <template v-for="(irow, i) in pop.phoneme.list" :key="i">
                                    <th>{{ irow.pron }}</th>
                                </template>
                            </tr>
                            <tr>
                                <td>Min-Max Length(ms)</td>
                                <template v-for="(irow, i) in pop.phoneme.list" :key="i">
                                    <td>{{ irow.min }}-{{ irow.max}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Average Length(ms)</td>
                                <template v-for="(irow, i) in pop.phoneme.list" :key="i">
                                    <td>{{ irow.avg.toFixed(1) }}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Length(ms)</td>
                                <template v-for="(irow, i) in pop.phoneme.list" :key="i">
                                    <td>{{ irow.len }}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Percentage error(%)</td>
                                <template v-for="(irow, i) in pop.phoneme.list" :key="i">
                                    <td>{{ irow.erate }}</td>
                                </template>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import PitchChart from '@/components/Charts/PitchChart';
import IntensityChart from '@/components/Charts/IntensityChart';
import ReumFileUploader from "@/components/ReumLib/UI/ReumFileUploader.vue";

export default {
    name: "View",
    components: {
    PitchChart,
    IntensityChart,
    ReumFileUploader,
},
    props:{ },
    setup() {
        const toast  = useToast();
        const router = useRouter();
        const route = useRoute();
        const store = useStore()

        const pop = reactive({
            view : { idx:0, show:'N', phonemes:[], result:[], text:'', hover:-1, vpath:'', avg_score:0, avg_grade:0, len_tot:0, words_cnt:0 },
            phoneme : { idx:-1, show:false, list:[], token:"" },
            pitch : { w:'538', h:'150', labels:[], datalist:[[], []] },
            intensity : { w:'538', h:'150', labels:[], datalist:[[], []] },

            showView:(iv)=>{
                if( comp.control.lens.length <= 0 ) return

                if( !iv.avg_score ) return

                pop.view.idx = iv.idx
                pop.view.phonemes = iv.phonemes
                pop.view.result = iv.result
                pop.view.text = iv.script
                pop.view.vpath = iv.vpath
                pop.view.avg_score = iv.avg_score
                pop.view.avg_grade = iv.avg_grade
                pop.view.len_tot = iv.len_tot
                pop.view.words_cnt = iv.words_cnt

                pop.view.show = 'Y'

                pop.view.best_match = iv.pitch_answer_best

                pop.makeChartData()
            },
            makeChartData:() => {
                let list = pop.view.result

                pop.pitch.labels = []
                pop.pitch.datalist = [{label:'Student Pitch', data:[]}]

                pop.intensity.labels = []
                pop.intensity.datalist = [{label:'Student Intensity', data:[]}]

                // 사용자 입력 음성
                let data_cnt = 0
                for(let i=0; i<list.length; i++) {
                    let irow = list[i]

                    pop.pitch.labels.push(irow['pron'])
                    pop.pitch.datalist[data_cnt]['data'].push(irow['pitch_fit'])


                    pop.intensity.labels.push(irow['pron'])
                    pop.intensity.datalist[data_cnt]['data'].push(irow['intensity_fit'])

                }

                // 비교 대상 원어민 음성
                data_cnt++
                list = comp.control.list

                let best_idx = (comp.control.idxl.indexOf(pop.view.best_match))
                for(let i=0; i<list.length; i++) {
                    let irow = list[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j]

                        // native n pitch add
                        if( !pop.pitch.datalist[data_cnt] ) {
                            pop.pitch.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Pitch ',
                                data : []
                            }

                            if( i==best_idx ){
                                pop.pitch.datalist[data_cnt].label = 'Best Match'
                                pop.pitch.datalist[data_cnt].isBest = true
                            }
                        }
                        pop.pitch.datalist[data_cnt]['data'].push(jrow['pitch_fit'])


                        // native n intensity add
                        if( !pop.intensity.datalist[data_cnt] ) {
                            pop.intensity.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Intensity ',
                                data : []
                            }
                        }
                        pop.intensity.datalist[data_cnt]['data'].push(jrow['intensity_fit'])
                    }

                    data_cnt++
                }

            },
            hideView:()=>{
                pop.deSelect()
                pop.view.show = 'N'
                pop.view.idx = ''
                pop.view.phonemes = []
                pop.view.result = []
                pop.view.text = ''
                pop.view.vpath = ''
                pop.view.avg_score = 0
                pop.view.avg_grade = 0
                pop.view.len_tot = 0
                pop.view.words_cnt = 0
            },
            onHover:(j) => {
                pop.view.hover = j
            },
            onSelect:(j)=>{
                pop.phoneme.idx = j
                pop.phoneme.show = true
                pop.phoneme.token = pop.view.phonemes[j].token
                pop.phoneme.list = pop.view.phonemes[j].analysis
                // console.log(pop.phoneme.list)
            },
            deSelect:() => {
                pop.phoneme.idx = -1
                pop.phoneme.show = false
            }

        })

        const comp = reactive({
            audioplayer : null, audioplayer2 : null,
            idx:0, uidx:0,
            info: {
                text:"",
                status: 0,
                chunks: [],
                mergeURL: null,
                source:null,
                base64: null,
                isnative:false,
            },
            rec_config: {
                audio: true,
                video:false
            },
            recorder : null,
            list:[], total:0,
            play: { idx:0, vpath:"", status:0 },
            selected: [],
            modified: { idx:'', script:'' },
            view : {
                idx : 0,
                script: '',
                phonemes:[],
            },
            control : {
                // 분석 대상이 되는 원어민
                idxl : [],
                list : [],
                lens : [],
                pers : [],
                avgs : [],
                base : { best:10, good:20, average:30, fair:40, poor:'etc', pitch_weight:30 }
            },
            mp3up : {
                is_show : false,
                filename : '',
                url: '',
                is_native:'N'
            },

            gotStream: (mediaStream) => {
                console.info("gotStream");
                comp.info.status = 2;
                window.streamReference = mediaStream;
                comp.recorder = null;
                comp.recorder = new MediaRecorder(mediaStream);
                comp.recorder.start(100);
                comp.recorder.ondataavailable = comp.audioDataHandler;
            },
            onRecording: () => {
                switch(comp.info.status){
                    case 2: comp.onStop(); break;
                    default: comp.onRecord(); break;
                }
            },
            onRecord: () => {
                console.info("Record");
                comp.info.status = 1;
                comp.info.chunks = [];
                navigator.mediaDevices.getUserMedia(comp.rec_config)
                .then(comp.gotStream)
                .catch(err => {
                    console.error(err.name + ": " + err.message)
                    toast.error(err.name + ": " + err.message)
                    comp.info.status = 0;
                });
            },
            onStop: () => {
                console.info("Stop");
                comp.info.status = 3;
                if (!window.streamReference) {
                    return;
                }
                window.streamReference.getAudioTracks().forEach(track => {
                    track.stop();
                });
                window.streamReference = null;

            },
            onSendVoice: () => {
                let params = {
                    idx: comp.idx,
                    isnative: comp.info.isnative==true?'Y':'N',
                    raw:comp.info.base64,
                    uidx: comp.uidx
                }
                axios.post("/ai/voice_upload", params).then((res) => {
                    if(res.data.err == 0) {
                        comp.info.base64 = null
                        comp.info.mergeURL = null
                        toast.success("전송했습니다.");
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg);
                    }
                }).catch((err) => {
                    toast.error("연결에 오류가 있습니다. :: ", err);
                });
            },
            audioDataHandler(event){
                console.info("Push");
                comp.info.chunks.push(event.data);
                if(comp.info.status == 3) {
                    let mergeBlob = new Blob(comp.info.chunks,{type:'audio/wav; codecs=MS_PCM'})
                    comp.info.mergeURL = URL.createObjectURL(mergeBlob);

                    let reader = new FileReader();
                    reader.onload = function(event){
                        comp.info.base64 = event.target.result;
                    }; // data url!
                    comp.info.source = reader.readAsDataURL(mergeBlob);
                    comp.info.status = 0;
                }
            },
            onPlay:(o) => {
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    // let audioplayer = document.getElementById("audioplayer2")
                    setTimeout(() =>{
                        comp.audioplayer2.play();
                    }, 200)

                } else {
                    comp.play.idx = 0
                    comp.play.vpath = ""
                    // let audioplayer = document.getElementById("audioplayer")
                    setTimeout(() =>{
                        comp.play.status = 1
                        comp.audioplayer.play();
                    }, 200)
                }
            },
            gotEnded:() => {
                console.log('play done')
                comp.play.idx = 0
                comp.play.status = 0
            },

            doInfo: () => {
                let params = {
                    idx : comp.idx
                }
                axios.get("/ai/script_info", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.view = res.data
                        // comp.(comp.view.phonemes)
                    }
                })
            },

            doSearch: () => {
                let params = {
                    idx : comp.idx
                }
                axios.get("/ai/voice_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list

                        for(let i=0; i<comp.list.length; i++){
                            let irow = comp.list[i]
                            irow['native'] = false
                            if( irow.isnative == 'Y' ){
                                comp.selected.push(irow.idx)
                                irow['native'] = true
                            }
                        }

                        comp.doEvaluates()
                    }
                })
            },

            updateScore:(o)=>{
                let params = { idx:o.idx, score:o.demo_no }
                axios.post('/ai/update_score', params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                    } else {
                        toast.error("refresh and re-operate.")
                    }
                })
            },

            updateNative:(idx)=>{
                let params = { idx:idx }
                axios.post('/ai/update_native', params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                    } else {
                        toast.error("refresh and re-operate.")
                    }
                })
            },

            mkClass:(ir, j)=>{
                let jr = ir.phonemes[j]
                return 'phonemes-' + j + ' ' + (!jr.grade?'':jr.grade)
            },

            selectNative:(idx)=>{
                if( comp.selected.indexOf(idx) > -1 ){
                    comp.selected.splice(comp.selected.indexOf(idx), 1)
                } else {
                    comp.selected.push(idx)
                }
                if( comp.selected.length <= 0 ){
                    toast.warning("You must select at least one.")
                    comp.selected.push(idx)
                }
                // console.log(comp.selected.indexOf(idx), comp.selected)

                comp.doEvaluates()
            },

            doEvaluates: () => {
                comp.getRules()
                // console.log(comp.control)

                for(let i=0; i<comp.list.length; i++){
                    let irow = comp.list[i]

                    irow = comp.doEvaluate(irow)
                }
            },

            cnt : 0, 
            makeTokenScript: (s, t) => {
                let pos = 0
                let cs = s

                comp.cnt++
                for(let i=0; i<t.length; i++){
                    let irow = t[i]

                    let token = irow['token'].toLowerCase()
                    let pron = irow['phonemes'].join('')

                    pos = cs.toLowerCase().indexOf(token)

                    let ct = ''
                    let pt = ''
                    if( pos >= 0 ){
                        ct = cs.substr(0, pos + token.length)
                        pt = cs.substr(0, pos) + pron
                    } else {
                        console.log(cs, token)
                        // if( comp.cnt == 1 ) console.log(cs, '|', token)
                    }

                    if( i == t.length - 1 ){
                        ct = cs.substr(0)
                        pt += cs.substr(pos + token.length)
                    }

                    // if( comp.cnt == 1 ) console.log(i, cs, '|', ct, pos, pos + ct.length)

                    irow['token_txt'] = ct
                    irow['pron_txt'] = pt
                    cs = cs.substr(ct.length)

                    t[i] = irow

                }

                return t
            },

            doEvaluate: (target) => {
                // 평가 함수
                if( comp.control.lens.length == 0 ) return

                let lens = comp.control.lens
                
                comp.makeTokenScript(target.script, target.phonemes)

                // 단어 수
                target.words_cnt = target.script.split(' ').length

                // length evaluate
                let len_tot = 0
                for(let i=0; i<target.result.length; i++){
                    let irow = target.result[i];

                    let len = lens[i]
                    // let per = pers[i]

                    if( lens.length - 1 < i ) continue;
                    irow.min = len.min
                    irow.max = len.max

                    let best = parseFloat(comp.control.base.best)
                    let good = parseFloat(comp.control.base.good)
                    let average = parseFloat(comp.control.base.average)
                    let fair = parseFloat(comp.control.base.fair)

                    if( len.min * ((100-best)/100) <= irow.len && irow.len <= len.max * ((100+best)/100) ){
                        // best score
                        irow.score = 5
                    } else if( len.min * ((100-good)/100) <= irow.len && irow.len <= len.max * ((100+good)/100) ){
                        // good score
                        irow.score = 4
                    } else if ( len.min * ((100-average)/100) <= irow.len && irow.len <= len.max * ((100+average)/100) ){
                        // average score
                        irow.score = 3
                    } else if ( len.min * ((100-fair)/100) <= irow.len && irow.len <= len.max * ((100+fair)/100) ){
                        // fair score
                        irow.score = 2
                    } else {
                        // poor score
                        irow.score = 1
                    }

                    irow.avg = comp.control.avgs[i]
                    irow.erate = Math.round((Math.abs(comp.control.avgs[i]-irow.len)/comp.control.avgs[i])*100)                    // error rate calculate
                    irow.rate = 100 - irow.erate

                    len_tot += irow.len

                    target.result[i] = irow
                }
                target['len_tot'] = len_tot*10                // 10분의 1초이므로 초단위로 변경


                // pitch dir evaluate
                target = comp.doEvaluatePitch(target)


                let avg_grade = ''
                let avg_score = 0
                if( target.result.length <= 0 ) {
                    target['avg_grade'] = avg_grade
                    return target
                }
                
                let index = 0
                for(let i=0; i<target.phonemes.length; i++){
                    let irow = target.phonemes[i]

                    let total = 0
                    let grade = ''
                    let analysis = []
                    for(let j=0; j<irow.jsgf.length; j++){
                        let jrow = target.result[index]

                        // 분석결과 저장
                        analysis.push({ pron:jrow.pron, min:jrow.min, max:jrow.max, rate:jrow.rate, erate:jrow.erate, len:jrow.len, avg:jrow.avg })
                        // 스코어 합계 계산
                        total += jrow.score

                        index++
                    }

                    irow.analysis = analysis

                    irow.total = total

                    // 스코어 등급 계산
                    let score = Math.round(total/irow.jsgf.length)
                    grade = comp.getGrade(score)
                    irow.score = score
                    irow.grade = grade

                    avg_score += score

                    target.phonemes[i] = irow
                }

                // console.log(avg_score, target.phonemes.length, avg_score/target.phonemes.length)
                target['avg_score'] = (avg_score/target.phonemes.length)
                avg_grade = comp.getGrade(Math.round(target['avg_score']))
                target['avg_grade'] = avg_grade

                // pitch dir extension score
                let pitch_weight = comp.control.base.pitch_weight/100
                target['avg_score_p'] = ((target['avg_score']*20)*(1-pitch_weight) + target['pitch_answer_rate']*pitch_weight)/20
                target['avg_grade_p'] = comp.getGrade(Math.round(target['avg_score_p']))

                // console.log(target.idx, (target['avg_score']*20) + ':' + (target['avg_score']*20)*0.8 + '  |  ' + target['pitch_answer_rate'] + ':' + target['pitch_answer_rate']*0.2 + '  |  ', target['avg_score_p'])

                return target
            },

            doEvaluatePitch: (target) => {
                // pitch dir evaluate
                target['pitch_answer'] = []
                target['pitch_answer_cnt'] = 0
                target['pitch_answer_rate'] = 0
                // best match
                target['pitch_answer_best'] = 0;
                if( target.result.length > 0 ){
                    for(let i=0; i<comp.control.list.length; i++){
                        let irow = comp.control.list[i]

                        let pitch_ans = 0
                        for(let j=0; j<irow.length; j++){
                            let srow = irow[j]
                            let trow = target.result[j]

                            if( !trow ) continue;

                            if(srow['pitch_dir'] == trow['pitch_dir']){
                                pitch_ans++
                            }
                        }

                        if( !target['pitch_answer_cnt'] ) target['pitch_answer_cnt'] = 0
                        if( !target['pitch_answer_rate'] ) target['pitch_answer_rate'] = 0

                        target['pitch_answer_cnt'] += pitch_ans
                        target['pitch_answer_rate'] += pitch_ans / target.result.length * 100

                        target['pitch_answer'].push({
                            idx : comp.control.idxl[i],
                            cnt : pitch_ans, 
                            rate : pitch_ans / target.result.length * 100
                        })
                    }
                    target['pitch_answer_cnt'] = target['pitch_answer_cnt'] / comp.control.list.length
                    target['pitch_answer_rate'] = target['pitch_answer_rate'] / comp.control.list.length

                    // best match index
                    let bestMatch = (obj) => {
                        const sortedEntriesByVal = Object.entries(obj).sort(([, v1], [, v2]) => v1['rate'] - v2['rate']);

                        return sortedEntriesByVal[sortedEntriesByVal.length - 1][1]['idx'];
                    };


                    target['pitch_answer_best'] = bestMatch(target['pitch_answer'])

                    // console.log(target['pitch_answer'], target['pitch_answer_cnt'], target['pitch_answer_rate'], target['pitch_answer_best'])
                }
                return target
            },

            getGrade:(score)=> {
                let grade = 'poor';
                switch(score){
                    case 5: grade = 'best'; break;
                    case 4: grade = 'good'; break;
                    case 3: grade = 'average'; break;
                    case 2: grade = 'fair'; break;
                    case 1: grade = 'poor'; break;
                }
                return grade;
            },

            getRules: ()=> {
                // 원어민 표본 계산
                let control = []
                comp.control.idxl = []
                for(let i=0; i<comp.list.length; i++){
                    let irow = comp.list[i]
                    if( comp.selected.indexOf(irow.idx) >= 0 ){
                        comp.control.idxl.push(irow.idx)
                        control.push(irow.result)
                    }
                }
                comp.control.list = control

                let lens = []
                let pers = []
                let avgs = []
                // let pitch = []
                // let pitch_avg = []
                // let intensity = []
                // let intensity_avg = []

                for(let i=0; i<control.length; i++){
                    let irow = control[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j];

                        let len = { min:100, max:0 };
                        let per = { min:100, max:0 };

                        if( i > 0 ){
                            len = lens[j]
                            per = pers[j]
                        }

                        if( j == 0 ){
                            len.max = jrow.len
                            per.max = jrow.per
                        }

                        if( !len ) continue;

                        // 대소값
                        if( jrow.len < len.min ) len.min = jrow.len
                        if( len.max < jrow.len ) len.max = jrow.len

                        // 일치율(계산 안됨)
                        if( jrow.per < per.min ) per.min = jrow.per
                        if( per.max < jrow.per ) per.max = jrow.per

                        lens[j] = len
                        pers[j] = per

                        // 평균값
                        if( !avgs[j] ) avgs[j] = []
                        avgs[j].push(jrow.len)

                        // pitch min/max
                        // intensity min/max
                    }
                }

                // 누산계산
                for(let i=0; i<avgs.length; i++){
                    avgs[i] = (avgs[i].reduce((a, b) => a + b, 0)/avgs[i].length);
                }

                comp.control.lens = lens
                comp.control.pers = pers
                comp.control.avgs = avgs

            },


            uploadMp3: () => {
                let param = {
                    idx: comp.idx,
                    path : comp.mp3up.url,
                    isnative : comp.mp3up.is_native,
                    uidx : comp.uidx
                }
                axios.post('/ai/mp3Link2Sample', param).then((res) => {
                    if( res.data.err == 0 ){
                        comp.hideMp3UpBox()
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg)
                    }
                })
            },

            checkUpNative: () => {
                comp.mp3up.is_native = (comp.mp3up.is_native=='Y'?"N":"Y")
            },

            hideMp3UpBox: () => {
                comp.mp3up.is_show = false
                comp.mp3up.filename = ''
                comp.mp3up.url = ''
                comp.mp3up.is_native = 'N'
            }

        });

        onMounted(() => {
            comp.audioplayer = document.getElementById("audioplayer")
            comp.audioplayer2 = document.getElementById("audioplayer2")

            comp.idx = !route.params.idx?0:route.params.idx

            if( !comp.idx ) {
                router.back()
            }

            comp.uidx = store.state.user.idx

            comp.doInfo()
            comp.doSearch()

        });

        return { comp, pop };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .page-header {
        position:fixed; top:0; left:0; width:calc(100% - 90px); height:50px; z-index:910; background-color:#fff; border-bottom: 1px solid #ececec;
        .btn-back {
            position:fixed; top:5px; left:0; width:40px; height:40px; font-size:30px; text-align:center; line-height:40px; color:#929292; z-index:2;
        }
    }
    .voice-view {
        .voice-rec {
            padding:40px 0px 30px;
            &::after {
                display:block; content:''; clear:both;
            }
            .voice-script {
                font-size:1.5rem; text-align:center;
                .pron {
                    font-size:1rem; font-family: 'noto sans-serif';
                }
            }
            .btn-box {
                position:relative; margin-left:calc(50% - 30px); text-align:left; padding-top:10px; max-height:122px;
                -webkit-transition: .4s ease-in-out; -moz-transition: .4s ease-in-out; -o-transition: .4s ease-in-out; transition: .4s ease-in-out;
                visibility: visible;
                &.rec-end {
                    -webkit-transition: 1.0s ease-in-out; -moz-transition: 1.0s ease-in-out; -o-transition: 1.0s ease-in-out; transition: 1.0s ease-in-out;
                    left:-32px;
                }
                &::after {
                    display:block; content:''; clear:both;
                }
                &.hide {
                    opacity:0; max-height:0px; overflow:hidden; visibility: hidden;
                }
            }
            .btn {
                display:inline-block; width:60px; height:60px; padding: 3px 10px; margin-top:10px; border: 1px solid #ddd; border-radius: 50px; 
                color: #FFF; font-size:1.4rem; text-align:center;
                opacity: 0;
                -webkit-transition: .4s ease-in-out; -moz-transition: .4s ease-in-out; -o-transition: .4s ease-in-out; transition: .4s ease-in-out;
                &.btn-rec {
                    position: absolute; left: 0px; z-index:2;
                    -webkit-animation: slide 0.5s forwards; -webkit-animation-delay: 2s; animation: slide 0.5s forwards; animation-delay: 2s;
                    background-color: rgb(255, 81, 81);
                    opacity:1 !important;
                    &.active {
                        left:-62px;
                    }
                }
                &.btn-play {
                    background-color:rgb(132, 196, 49);
                }
                &.btn-native {
                    display: none;
                    margin-left:2px; font-size:13px; color:#666;
                    &.checked {
                        background-color:rgb(243, 210, 65); color:#fff;
                    }
                }
                &.btn-send {
                    display: none;
                    background-color: rgb(122, 134, 238); margin-left:2px;
                }
                &.active {
                    display:inline-block;
                    opacity: 1 !important; visibility: visible;
                }
                &.btn-up-open {
                    position:absolute;top:10px;left:60px;
                    opacity:1; background-color:rgb(136, 158, 106);
                    &.hide {
                        opacity:0; overflow:hidden; visibility: hidden;
                    }
                }
            }
            .upload-box {
                -webkit-transition: .4s ease-in-out; -moz-transition: .4s ease-in-out; -o-transition: .4s ease-in-out; transition: .4s ease-in-out;
                height:80px; padding-top:20px;
                &.hide {
                    height:0px; overflow:hidden; opacity:0;
                }
                .up-file {
                    display:inline-block; width:200px;
                }
                .btn-isnative {
                    width:22px; height:22px; font-size:16px; padding:0; vertical-align:middle;border: 1px solid rgb(2, 105, 2); border-radius: 3px; color:rgb(2, 105, 2); margin-left:1px;
                    &.active {
                        background-color:rgb(187, 227, 135); 
                    }
                }
                .btn-up-submit {
                    width:45px; height:22px; font-size:18px; padding:0; vertical-align:middle;background-color:rgb(122, 134, 238); border: 1px solid rgba(122, 134, 238, 0.8); border-radius: 3px; color:#fff; margin-left:1px;
                }
                .btn-close {
                    width:22px; height:22px; font-size:16px; padding:0; border:0; background:transparent; vertical-align:middle; margin-right:1px; color:#fc2415;
                }
                .chk-native {
                    padding-top:4px; font-size:12px;
                }
            }
        }

        .bar {
            position:relative; height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
            span {
                position:absolute; top:-10px; left:0; right:0; width:130px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
            }
        }

        .voice-list {
            padding:0 20px;
            .voice-item {
                position:relative; margin-bottom:5px; border-bottom:1px solid #c8c8c8; padding-bottom:5px;
                .title {
                    display:block; text-align:left; height:inherit; color:#929292;
                }
                &.grade-info {
                    .voice-body {
                        width:100%; margin:0;
                    }
                }
                .voice-body {
                    position:relative; margin-left:30px;
                    width:calc(100% - 60px); min-height:30px; text-align:left; vertical-align:middle;
                    display:flex;justify-content: left; align-items: center; padding:0 10px;
                    .script {
                        vertical-align:middle; cursor:pointer; word-break: break-word; line-height:20px;

                        .best { color:#4744f7; }
                        .good { color:#1da600; }
                        .average { color:#ffeb00; }
                        .fair { color:#fab905; }
                        .poor { color:#fc2415; }

                        .base-lv {
                            width:30px; height:20px; text-align:center; color:#666; margin-right:10px; border-radius:0; border: 1px solid #c8c8c8; font-size:12px; line-height:18px; outline:none; padding:0;
                        }

                        .btn-apply {
                            width:50px; height:20px; padding:0; border: 1px solid #c8c8c8; color:#666; font-size:12px;
                            &:hover {
                                border-color:#999; background-color:#d0d0d0; color:#fff;
                            }
                        }

                    }
                    .speech {
                        font-size:12px; margin-left:20px;
                    }
                    .body-tail {
                        
                        label {
                            margin-left:10px; 
                            padding-left:10px; border-left:1px solid #c8c8c8;
                        }
                        .demo-score {
                            width:60px; height:22px; font-size:12px; text-align:center; border-radius:0; outline:none; border:1px solid #c8c8c8;
                        }
                    }
                }
                .voice-head {
                    position:absolute; top:0; left:0; width:30px; height:30px; line-height:28px;
                    button {
                        width:100%; height:100%; border:0; border:1px solid #c8c8c8;
                        .la-check {
                            display:none;
                        }
                        &.checked {
                            background-color:rgb(187, 227, 135); color:rgb(2, 105, 2);
                            .la-check {
                                display:block;
                            }
                        }
                    }
                    .idx {
                        display:block; font-size:11px; margin-top:-10px;
                    }
                }
                .voice-tail {
                    position:absolute; top:0; right:0; width:30px; height:30px; line-height:28px; border:1px solid #c8c8c8;
                    button {
                        width:100%; height:100%; border:0;
                    }
                }
            }
        }


        
        .modal {
            position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; z-index: 999;
            background: rgba(0,0,0,.3); 
            display: none; flex-flow: column wrap; justify-content: center; align-items: center; opacity:0; transition : all 0.5s;
            &.open {
                display: flex; opacity:1;
                .modal-close {
                    position: absolute;
                    z-index: 3;
                }
            }
            &-close {
                top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%;
                cursor:pointer;
            }
            &-pop {
                z-index: 5;
                background: #fff; border-radius: 4px; width: 100%; max-width: 600px; min-height: 100px; padding:30px 20px; position:relative;
                .close {
                    position:absolute; top:-12px; right:-14px; width:20px; height:20px; border-radius:20px; cursor:pointer; font-size: 16px; line-height: 16px; color: #f0f0f0;
                }
            }
            &-body {
                text-align:left;
                .ex-box {
                    word-break: break-all;
                    font-size:1rem; color:#666; text-align:left; padding:10px; border:1px solid #c8c8c8;
                    .tit {
                        padding:20px 0 5px; font-size:11px;
                    }
                    .btn {
                        display:inline-block; border:1px solid rgba(29, 166, 0, 1); border-radius:20px; width:16px; height:16px; font-size:13px; line-height:15px; padding:0; margin:0; text-align:center; color:#fff; background-color:rgba(29, 166, 0, 0.6); vertical-align:top; margin-top:2px; margin-left:6px;
                    }
                    .script {
                        .speech {
                            font-size:15px; margin-left:20px;
                            &:first-child {
                                margin-left:0;
                            }
                        }
                    }
                }
                .result-box {
                    .hover {
                        background-color:rgba(0,0,0,0.1)
                    }
                    .best { color:#4744f7; }
                    .good { color:#1da600; }
                    .average { color:#ffeb00; }
                    .fair { color:#fab905; }
                    .poor { color:#fc2415; }
                    span {
                        font-size:11px;
                        > span {
                            font-size:18px; cursor:pointer;
                        }
                    }
                }
                .chart {
                    position:relative; width:100%; height:150px;
                }
            }
            .ex-pron {
                position:absolute; top:0; left:0; right:0; bottom:0; margin:auto;
                text-align:center; background-color:rgba(200,200,200,0.4); vertical-align: middle;
                .ex-box {
                    position:relative; display:inline-block;
                    vertical-align: middle; margin:50px auto 0; text-align:center;
                    table {
                        border-radius:4px; background-color:#fff; box-shadow: 0px 0px 8px #999;
                        th {
                            padding:10px 0 6px;
                            border-bottom:1px solid #c8c8c8;
                        }
                        td {
                            padding:6px 10px 10px;
                        }
                    }
                    .btn-ex-close {
                        position:absolute; top:-20px; left:calc(50% - 10px); width:20px; height:20px; background-color:transparent; border:0; line-height:20px; padding:0; color:#fff; font-size:16px; text-shadow: rgb(0, 0, 0) 0 0 8px;
                    }
                }
                .ex-bg {
                    position:absolute; top:0; left:0; width:100%; height:100%;
                }
            }
        }
    }
</style>
